<template>
  <v-tooltip open-delay="500" top>
    <template #activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon size="22" v-text="ICONE" />
      </v-btn>
    </template>
    <span v-text="label" />
  </v-tooltip>
</template>

<script>
export default {
  name: "NivelServico",
  props: {
    nivel_servico: String,
    label: String,
  },
  data: () => ({
    opcoes: {
      NIVEL_ELEVADO: '$NivelElevado',
      NIVEL_ALTO: '$NivelAlto',
      NIVEL_MEDIO: '$NivelMedio',
      NIVEL_BAIXO: '$NivelBaixo',
      NIVEL_ORDINARIO: '$NivelOrdinario',
    }
  }),
  computed: {
    CHAVE() {
      return `${this.nivel_servico}`
        .trim()
        .toUpperCase()
        .replace(' ', '_');
    },
    ICONE() {
      return this.opcoes[this.CHAVE];
    }
  }
}
</script>

<style scoped>

</style>
